"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.Link = Link;
exports.enhance = exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _clickTracking = _interopRequireDefault(require("./tracking-lib/tracking/clickTracking"));

/* eslint-disable jsx-a11y/mouse-events-have-key-events */
var enhance = _clickTracking["default"];
exports.enhance = enhance;

function Link(_ref) {
  var children = _ref.children,
      href = _ref.href,
      to = _ref.to,
      handleClick = _ref.handleClick,
      className = _ref.className,
      target = _ref.target,
      rel = _ref.rel,
      getRef = _ref.getRef,
      onMouseOut = _ref.onMouseOut,
      onMouseOver = _ref.onMouseOver;
  return to ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to,
    rel: rel,
    innerRef: getRef,
    onClick: handleClick,
    className: className,
    target: target,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver
  }, children) : /*#__PURE__*/_react["default"].createElement("a", {
    onClick: handleClick,
    href: href || to,
    rel: rel,
    ref: getRef,
    className: className,
    target: target,
    onMouseOut: onMouseOut,
    onMouseOver: onMouseOver
  }, children);
}

Link.propTypes = {
  /** Target of the link */
  href: _propTypes["default"].string,
  to: _propTypes["default"].string,
  rel: _propTypes["default"].string,
  getRef: _propTypes["default"].func,
  children: _propTypes["default"].node,
  handleClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  target: _propTypes["default"].string,
  onMouseOver: _propTypes["default"].func,
  onMouseOut: _propTypes["default"].func
};

var _default = enhance(Link);

exports["default"] = _default;